import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks (CWE-80).
 * Uses DOMPurify with a safe default configuration.
 *
 * This is the shared sanitization utility for the web client.
 * The configuration is a superset of the RichTextDisplay sanitizer,
 * adding support for tables, images, and structural elements needed
 * by report previews and rich content cards.
 *
 * @see components/ui/RichTextEditor/RichTextDisplay.tsx for the
 *      narrower config used by the rich text editor display.
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'p', 'br', 'hr',
      'ul', 'ol', 'li',
      'strong', 'b', 'em', 'i', 'u', 's', 'del',
      'a', 'blockquote', 'pre', 'code',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'div', 'span', 'img',
      'sub', 'sup',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'class', 'style', 'colspan', 'rowspan'],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'form', 'input', 'button'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover'],
  });
}
